module.exports = __webpack_public_path__ + "static/media/daily-mail-settings.3d918485.svg";